import {DeviceCategory} from "./device-category";
import {Tenant} from "./tenant";
import {TemplateContent} from "./template-content";

export class Template {
  uuid?: string;
  name: string;
  description: string;
  type: string;
  content: TemplateContent;
  deviceCategory?: DeviceCategory;
  tenant: Tenant;
  creationDate: number;
  updatedDate: number;
}
